import { ThemeProvider } from '@emotion/react'
import { CssBaseline } from '@mui/material'
import { BrowserRouter } from 'react-router-dom'
import { AppUpdateBootstrap } from './components/AppUpdate'
import { Toast } from './components/ui-kit'
import { Routes } from './routes'
import { PureLightTheme } from './styles/theme'
import ModalComponent from './components/ModalComponent'

const theme = () => {
  return PureLightTheme
}

const App = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <BrowserRouter>
      <AppUpdateBootstrap />
      <Routes />
      <ModalComponent />
      <Toast />
    </BrowserRouter>
  </ThemeProvider>
)

export default App
